module.exports = __webpack_public_path__ + "img/animated_loading.9c2f4488.gif";